import { Button, Result } from "antd";
import { useNavigate } from "react-router";
import { useMenu } from "./hooks/useMenu";

export function NotFound() {
  const navigate = useNavigate();
  const { atualizarMenuSelected } = useMenu();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Desculpe mas essa pagina não existe."
      extra={
        <Button
          type="primary"
          onClick={() => {
            navigate("/");
            atualizarMenuSelected(["inicio"]);
          }}
        >
          Ir para pagina inicial
        </Button>
      }
    />
  );
}
